import { Node } from '@tiptap/core'

/**
 * 图片上传占位节点 - 仅用于兼容旧内容（Schema 解析）
 *
 * - 背景：历史上上传中会插入 uploadImagePlaceholder 节点并落库，现已改为 Decoration，新内容不再包含此节点。
 * - 作用：若已保存的 JSON 中仍含 uploadImagePlaceholder，不注册此扩展会报 Unknown node type；注册后仅用于解析，不参与新逻辑。
 * - 展示：渲染为无内容、零占位的块（不显示「图片上传中」等文案）。
 * - 输出：TiptapEditor 的 onChange 已统一经 filterUploadPlaceholdersFromJSON 过滤，持久化/提交不会带出占位节点。
 */
export const UploadImagePlaceholder = Node.create({
    name: 'uploadImagePlaceholder',
    draggable: false,
    inline: false,
    group: 'block',

    addAttributes() {
        return {
            uploadId: { default: '' }
        }
    },

    parseHTML() {
        return [
            {
                tag: 'div[data-image-upload-id]',
                getAttrs: node => {
                    const uploadId = node.getAttribute('data-image-upload-id')
                    return uploadId ? { uploadId } : false
                }
            }
        ]
    },

    renderHTML({ node }) {
        return [
            'div',
            {
                'data-image-upload-id': node.attrs.uploadId,
                style: 'height:0; overflow:hidden; margin:0; padding:0; line-height:0; border:none;'
            }
        ]
    }
})
